import {
  GET_LOANS,
  GET_LOANS_SUCCESS,
  GET_LOANS_FAILURE,
  GET_60_DAY_LOANS,
  GET_60_DAY_LOANS_SUCCESS,
  GET_60_DAY_LOANS_FAILURE,
  GET_CASH_FLOW_LOANS,
  GET_CASH_FLOW_LOANS_SUCCESS,
  GET_CASH_FLOW_LOANS_FAILURE,
  GET_LOAN,
  GET_LOAN_SUCCESS,
  GET_LOAN_FAILURE,
  GET_LOAN_MATURITY_REPORT,
  GET_LOAN_MATURITY_REPORT_SUCCESS,
  GET_LOAN_MATURITY_REPORT_FAILURE,
} from './constants';


const initialState = {
  loans: { loans: [], loading: false, loaded: false, error: null },
  loans60Day: { loans: [], loading: false, loaded: false, error: null },
  cashFlow: { loans: [], loading: false, loaded: false, error: null },
  loan: { loan: {}, loading: false, loaded: false, error: null },
  loanMaturityReport: { report: [], loading: false, loaded: false, error: null },
};

const Loan = (state = initialState, action) => {
  switch (action.type) {
    /* — GET ALL LOANS — */
    case GET_LOANS:
      return {
        ...state,
        loans: { ...state.loans, loading: true, error: null },
      };
    case GET_LOANS_SUCCESS:
      return {
        ...state,
        loans: { loans: action.payload, loading: false, loaded: true, error: null },
      };
    case GET_LOANS_FAILURE:
      return {
        ...state,
        loans: { ...state.loans, loading: false, loaded: false, error: action.payload },
      };

    /* — GET 60-DAY LOANS — */
    case GET_60_DAY_LOANS:
      return {
        ...state,
        loans60Day: { ...state.loans60Day, loading: true, error: null },
      };
    case GET_60_DAY_LOANS_SUCCESS:
      return {
        ...state,
        loans60Day: { loans: action.payload, loading: false, loaded: true, error: null },
      };
    case GET_60_DAY_LOANS_FAILURE:
      return {
        ...state,
        loans60Day: { ...state.loans60Day, loading: false, loaded: false, error: action.payload },
      };  

    /* — GET CASH FLOW LOANS — */
    case GET_CASH_FLOW_LOANS: 
      return {
        ...state,
        cashFlow: { ...state.cashFlow, loading: true, error: null },
      };
    case GET_CASH_FLOW_LOANS_SUCCESS:
      return {
        ...state,
        cashFlow: { loans: action.payload, loading: false, loaded: true, error: null },
      };
    case GET_CASH_FLOW_LOANS_FAILURE:
      return {
        ...state,
        cashFlow: { ...state.cashFlow, loading: false, loaded: false, error: action.payload },
      };
    
    /* — GET LOAN — */
    case GET_LOAN:
      return {
        ...state,
        loan: { loading: true, error: null },
      };
    case GET_LOAN_SUCCESS:
      return {
        ...state,
        loan: { loan: action.payload, loading: false, loaded: true, error: null },
      };
    case GET_LOAN_FAILURE:
      return {
        ...state,
        loan: { ...state.loan, loading: false, loaded: false, error: action.payload },
      };

    /* — GET LOAN MATURITY REPORT — */
    case GET_LOAN_MATURITY_REPORT:
      return {
        ...state,
        loanMaturityReport: { loading: true, error: null },
      };
    case GET_LOAN_MATURITY_REPORT_SUCCESS:
      return {
        ...state,
        loanMaturityReport: { report: action.payload, loading: false, loaded: true, error: null },
      };
    case GET_LOAN_MATURITY_REPORT_FAILURE:
      return {
        ...state,
        loanMaturityReport: { ...state.loanMaturityReport, loading: false, loaded: false, error: action.payload },
      };
    default:
      return state;
  }
};

export default Loan;
